import { defineStore } from 'pinia'

import { getLogin, getLogout } from '@/api/auth-routes'
import { setAccessToken, removeAccessTokens } from '@/helpers/auth-helper'

import { useDefaultStore } from '@/store/defaultStore'

export const useAuthorizationStore = defineStore('authorizationStore', {
    state: () => ({
        login: false,
        loading: false,
    }),
    actions: {
        async goToLogin(formData) {
            if (this.loading) {
                return
            }

            const defaultStore = useDefaultStore()

            this.loading = true

            const { success, message, payload } = await getLogin(formData)

            if (success && !!payload?.access_token) {
                setAccessToken(payload.access_token)
                this.setIsUserLogin(true)
                defaultStore.setSuccessMessage({ message })
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.loading = false

            return { success }
        },

        setIsUserLogin(value) {
            this.login = value
        },

        async goToLogout() {
            const defaultStore = useDefaultStore()

            const { success, message } = await getLogout()

            if (success) {
                defaultStore.setSuccessMessage({ message })
                this.$reset()
                removeAccessTokens()
            } else {
                defaultStore.setErrorMessage({ message })
            }
        },
    },
})
